import { render, staticRenderFns } from "./inventory-history-modal.vue?vue&type=template&id=74e241c6"
import script from "./inventory-history-modal.vue?vue&type=script&lang=js"
export * from "./inventory-history-modal.vue?vue&type=script&lang=js"
import style0 from "./inventory-history-modal.vue?vue&type=style&index=0&id=74e241c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports